module.exports = __webpack_public_path__ + "static/img/GettyImages-485206425.abd6de7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/GettyImages-485206425.jpg
// module id = Bo9A
// module chunks = 0